import { useFeatureValue } from '@growthbook/growthbook-react';
import { GrowthBookFeature } from '@gumtree/shared/src/model/experiment';
import { L1CategoryIds, LeafCategoryIdsInForSalePaid } from '@gumtree/shared/src/types/categories';
import { FiltersOrder } from '../get-data/transform/filters-order';

export const shouldHideSellerTypeFilter = (categories: number[]): boolean => {
    if (!categories) return false;

    const isForSale = categories?.[0] === L1CategoryIds.FOR_SALE;

    const isForSalePaidCategories = [
        LeafCategoryIdsInForSalePaid.SOFA,
        LeafCategoryIdsInForSalePaid.SOFA_BEDS_FUTONS,
        LeafCategoryIdsInForSalePaid.WARDROBES_SHELVING_STORAGE,
        LeafCategoryIdsInForSalePaid.MATTRESSES,
        LeafCategoryIdsInForSalePaid.SINGLE_BEDS,
        LeafCategoryIdsInForSalePaid.DOUBLE_BEDS,
    ].includes(categories?.[categories.length - 1]!);

    return (
        useFeatureValue(GrowthBookFeature.FOR_SALE_SELLER_TYPE_BUYER, 'A') !== 'B' &&
        isForSale &&
        !isForSalePaidCategories
    );
};

export const removeSellerTypeFromFilterKeys = (filtersOrder: FiltersOrder): void => {
    const index = filtersOrder?.indexOf('seller_type');
    index > -1 && filtersOrder.splice(index, 1);
};
